import { useAppSelector } from '@/redux/hooks'
import { useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import {
  buttonName,
  confirmMessages,
  errorMessages,
  fieldMessages,
  FormData,
} from '../boardItem'
import { PrivacyContents } from '../_components/privacyPolicy'
import { InquriyInsertForm } from './inquiryInsertForm'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

export const InquiryInsertGuest = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const { showAlert, showConfirm } = useDialog()
  const [showPolicyPopup, setShowPolicyPopup] = useState<boolean>(false)
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)
  const [formData, setFormData] = useState({
    cmpnyCd: '001',
    bbsTy: '01',
    nttSj: '',
    nttCn: '',
    bbsSj: '',
    cstId: isAuthenticated ? user?.cstId : 'GUEST',
    regId: isAuthenticated ? user?.cstId : 'GUEST',
    guestName: '',
    guestEml: '',
    guestTermAgree: false,
  })

  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault() // 기본 폼 제출 동작 방지

    const emailValue = formData.guestEml // 이메일 필드 값

    // 필수 입력 필드와 메시지 매핑
    const requiredFields: { field: keyof FormData; message: string }[] = [
      { field: 'bbsSj', message: fieldMessages.bbsSj },
      { field: 'nttSj', message: fieldMessages.nttSj },
      { field: 'nttCn', message: fieldMessages.nttCn },
      { field: 'guestName', message: fieldMessages.guestName },
      { field: 'guestEml', message: fieldMessages.guestEml },
      {
        field: 'guestTermAgree',
        message: fieldMessages.guestTermAgree,
      },
    ]

    for (const { field, message } of requiredFields) {
      const value = formData[field]

      if (field === 'guestTermAgree') {
        if (!value) {
          showAlert({
            type: 'warning',
            title: message,
          })
          return
        }
      }
      // 문자열인 경우 공백 제거 후 체크
      if (typeof value === 'string' && !value.trim()) {
        showAlert({
          type: 'warning',
          title: message,
        })
        return
      }

      if (!formData[field]) {
        showAlert({
          type: 'warning',
          title: message,
        })
        return
      }
    }

    // 이메일 유효성 검사
    const emailRegex = /^[a-zA-Z0-9._-]{2,}@[a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,}$/
    if (!emailRegex.test(emailValue)) {
      showAlert({
        type: 'warning',
        title: '올바른 이메일을 입력해 주세요.',
      })
      return
    }

    // 확인창 및 등록 실행
    showConfirm({
      title: confirmMessages.insert,
      confirmBtnName: buttonName.confirm,
      cancelBtnName: buttonName.cancel,
      onConfirm() {
        insertBoard()
      },
    })
  }

  const handleChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement // 타입 캐스팅
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  // const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   console.log('체크박스 클릭됨:', e.target.name, e.target.checked)
  //   const { name, checked } = e.target
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: checked ? 'Y' : 'N',
  //   }))
  // }

  // const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, checked } = e.target
  //   console.log('체크박스 클릭됨:', name, checked)
  //   console.log('변경 전 formData:', formData.guestTermAgree) // 이 값을 확인

  //   setFormData((prevState) => {
  //     const newData = {
  //       ...prevState,
  //       [name]: checked ? 'Y' : 'N',
  //     }
  //     console.log('변경 후 formData:', newData.guestTermAgree) // 이 값도 확인
  //     return newData
  //   })
  // }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target
    console.log('체크박스 클릭됨:', name, checked)
    console.log('변경 전 formData:', formData.guestTermAgree) // 이 값을 확인
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked, // 'Y'/'N' 대신 boolean 값 저장
    }))
  }
  const handleList = () => {
    showConfirm({
      title: confirmMessages.cancel,
      confirmBtnName: buttonName.confirm,
      cancelBtnName: buttonName.cancel,
      onConfirm() {
        insertBoard()
      },
    })
  }

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click() // 숨겨진 파일 입력창 열기
    }
  }

  const openPrivacyPolicy = () => {
    showAlert({
      type: 'warning',
      title: '[필수] 개인정보 수집 및 이용 동의',
      message: <PrivacyContents />,
    })
  }

  const insertBoard = async () => {
    const submitData = {
      ...formData,
      guestTermAgree: formData.guestTermAgree ? 'Y' : 'N',
    }
    try {
      await axios.post(`/inquiry/insert`, submitData) // POST 요청
      setTimeout(() => {
        navigate(`/inquiry`)
      }, 300)
    } catch (err: any) {
      showAlert({
        type: 'error',
        title: errorMessages.insert,
      })
    }
  }

  return (
    <>
      <InquriyInsertForm
        formData={formData}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        handleCheckboxChange={handleCheckboxChange}
        handleButtonClick={handleButtonClick}
        handleList={handleList}
        openPrivacyPolicy={openPrivacyPolicy}
        showPolicyPopup={showPolicyPopup}
        setShowPolicyPopup={setShowPolicyPopup}
        navigate={navigate}
        insertBoard={insertBoard}
        isAuthenticated={isAuthenticated}
      />
    </>
  )
}
